// ProgressBar for multistep form indication
import React from "react";
// import { useNavigate } from "react-router-dom";

interface ProgressStep {
  label: string;
  active: boolean;
  path?: string;
}

interface ProgressBarProps {
  steps: ProgressStep[];
}

const ProgressBar: React.FC<ProgressBarProps> = ({ steps }) => {
  // const navigate = useNavigate();

  // const handleClick = (path?: string) => {
  //   if (path) {
  //     navigate(path);
  //   }
  // };

  return (
    <div className="flex flex-row justify-center items-center gap-4 my-8">
      {steps.map((step, idx) => {
        const circleClasses = step.active
          ? "bg-[#01545D] border-[#01545D] text-white"
          : "bg-white border-[#DCE1E8] text-[#818BA0] hover:border-[#01545D] hover:text-[#01545D]";
        // const clickable = Boolean(step.path);

        const content = (
          <>
            <div
              className={`w-10 h-10 flex items-center justify-center rounded-full border-2 transition-colors duration-150 ${circleClasses}`}
            >
              {idx + 1}
            </div>
            <span
              className={`text-xs mt-2 text-center ${step.active ? "text-[#01545D]" : "text-[#818BA0]"}`}
            >
              {step.label}
            </span>
          </>
        );

        // Steps are not clickable - always render as div
        // if (clickable) {
        //   return (
        //     <button
        //       key={step.label}
        //       type="button"
        //       onClick={() => handleClick(step.path)}
        //       className="flex flex-col items-center focus:outline-none"
        //     >
        //       {content}
        //     </button>
        //   );
        // }

        return (
          <div className="flex flex-col items-center" key={step.label}>
            {content}
          </div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
